<template>
  <main class="md-layout md-alignment-bottom-space-around">
    <md-toolbar class="d-dense header" md-elevation="1">
      <h3 class="md-title" style="flex: 1">
        <router-link :to="{name: 'MapLogin'}">
          <img src="https://cdn.jon-api.com/shikaku-map/img/logo.png">
        </router-link>
      </h3>
    </md-toolbar>

    <form class="md-layout md-alignment-center" @submit.prevent="formValidate" novalidate>
      <md-card class="md-layout-item md-size-40 md-xsmall-size-100 md-alignment-center">
        <md-card-header>
          <div class="md-title">ログイン</div>
        </md-card-header>

        <md-card-content class="md-layout-item md-layout md-alignment-center">
          <div class="md-layout-item md-size-80 md-small-size-100">
            <flash-message :errors="errorMessages"
                           :class="{'maintenance-flash-message': isMaintenanceError}"
                           class="md-layout-item md-size-100"
                           v-if="errorMessages.length">
              <div v-if="isMaintenanceError" class="maintenance-detail">
                <a class="maintenance-detail-link"
                   :href="maintenance_info_url"
                   target="_blank"
                   rel="noopener noreferrer">メンテナンス詳細</a>
              </div>
            </flash-message>
          </div>
          <md-field class="md-layout-item md-size-60 md-small-size-100" :class="getValidationClass('login_id')">
            <label>ログインID</label>
            <md-input name="login_id" v-model="form.login_id" required autofocus :disabled="sending"/>
            <validation-error v-if="getValidationResponseMessage('login_id')"
                              :error="getValidationResponseMessage('login_id')"></validation-error>
            <validation-error :error="errors.login_id.required"
                              v-else-if="!$v.form.login_id.required"></validation-error>
            <validation-error :error="errors.login_id.loginId"
                              v-else-if="!$v.form.login_id.loginId"></validation-error>
          </md-field>
          <md-field class="md-layout-item md-size-60 md-small-size-100" :class="getValidationClass('password')">
            <label>パスワード</label>
            <md-input type="password" name="password" v-model="form.password" required :disabled="sending"/>
            <validation-error v-if="getValidationResponseMessage('password')"
                              :error="getValidationResponseMessage('password')"></validation-error>
            <validation-error :error="errors.password.required"
                              v-else-if="!$v.form.password.required"></validation-error>
            <validation-error :error="errors.password.password"
                              v-else-if="!$v.form.password.password"></validation-error>
          </md-field>
          <div class="md-layout-item md-size-80 md-small-size-100 md-layout md-alignment-center">
            <router-link :to="{name: 'ForgotAccount'}">
              <label class="md-caption forgot-account-link">ID・パスワードをお忘れの方はこちら</label>
            </router-link>
          </div>
          <div class="md-layout-item md-size-80 md-small-size-100 md-layout md-alignment-center">
            <a :href="maintenance_info_url"
               target="_blank"
               rel="noopener"
               class="md-caption forgot-account-link">障害・メンテナンス情報はこちら</a>
          </div>
        </md-card-content>

        <md-card-actions class="md-layout md-alignment-center md-20">
          <md-button :disabled="sending" class="md-primary md-raised" type="submit">
            <md-icon>exit_to_app</md-icon>
            <span>ログイン</span>
          </md-button>
        </md-card-actions>

        <md-card-content class="md-layout-item md-layout md-alignment-center">
          <div :class="getValidationClass('password')"
               class="md-layout-item md-layout md-size-100 md-alignment-center-center">
            <a href="/terms" rel="noopener" tag="md-button" target="_blank">利用規約</a>
            <a class="ml-20" href="https://www.jon.co.jp/privacy/" rel="noopener" target="_blank">個人情報保護方針</a>
            <a class="ml-20" href="/legal" rel="noopener" tag="md-button" target="_blank">特定商取引法に基づく表記</a>
          </div>
        </md-card-content>
      </md-card>
    </form>

    <md-toolbar class="d-dense" md-elevation="1">
      <a class="ml-20" href="https://www.jon.co.jp/aboutus/company/" rel="noopener" target="_blank">企業情報</a>
      <a class="ml-20" href="/faq" rel="noopener" style="flex: 1"
         target="_blank">お問い合わせ・FAQ</a>
      <span>Copyright © JON Inc. All Rights Reserved.</span>
    </md-toolbar>

    <md-dialog :md-fullscreen="false"
               :md-active.sync="showSuspectedDuplicateLoginDialog">
      <md-dialog-title>ログインの確認</md-dialog-title>
      <md-dialog-content>
        このアカウントは他端末にて現在ログイン中です。<br/>
        ログインすると他端末では自動的にログアウトとなります。<br/>
        <span class="md-caption">（規約で許諾された場合を除き、複数人でのアカウント共有はお控えください）</span><br/>
        <br/>
        ログインしますか？
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :class="'md-raised'" @click="onCancel">
          <md-icon>close</md-icon>
          <span>キャンセル</span>
        </md-button>
        <md-button :class="'md-raised md-primary'" @click="onSubmit">
          <md-icon>check</md-icon>
          <span>OK</span>
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </main>
</template>

<script>
import FlashMessage                                 from "../../../components/FlashMessage";
import ValidationError                              from "../../../components/ValidationError";
import Validation                                   from "../../../modules/validation";
import {apiClient, apiClientWithUserToken, apiList} from '../../../modules/apiClient';
import {validationMixin}                            from 'vuelidate'
import CommonMixin                                  from "../../../mixins/commonMixin";
import {required}                                   from 'vuelidate/lib/validators';
import Common                                       from "../../../modules/common";
import LoadingSpinnerOverlay                        from "../../../components/LoadingSpinnerOverlay.vue";

export default {
  name      : "MapLogin",
  components: {
    LoadingSpinnerOverlay,
    FlashMessage,
    ValidationError,
  },
  mixins    : [validationMixin, CommonMixin],
  data      : () => ({
    form                             : {
      login_id: null,
      password: null,
      meta    : {},
    },
    maintenance_info_url             : process.env.VUE_APP_MAINTENANCE_INFO_URL ? process.env.VUE_APP_MAINTENANCE_INFO_URL : 'https://www.jon.co.jp/failure_maintenance/',
    errors                           : {
      login_id: {
        required: Validation.errorMessage(Validation.rules.required, 'loginId'),
        loginId : Validation.errorMessage(Validation.rules.loginId, 'loginId'),
      },
      password: {
        required: Validation.errorMessage(Validation.rules.required, 'password'),
        password: Validation.errorMessage(Validation.rules.password, 'password'),
      }
    },
    showSuspectedDuplicateLoginDialog: false,
  }),
  computed  : {
    /**
     * メンテナンスエラーが表示対象か判定する。
     *
     * @returns {boolean} メンテナンスエラーの場合は true
     */
    isMaintenanceError() {
      return this.errorMessages.includes(Common.messages.errorMaintenanceMode);
    },
  },
  validations() {
    return {
      form: {
        login_id: {
          required,
          loginId: Validation.loginId,
        },
        password: {
          required,
          password: Validation.password,
        },
      }
    };
  },
  created() {
    /**
     * ブラウザフィンガープリントを用いたクライアント識別を行う
     *
     * 1．fingerPrint2を利用したフィンガープリントの取得
     * 2. fingerPrint2を利用したメタ情報の取得
     */
    this.$fingerprint.get((components) => {
      this.generateUserMeta(components);

      window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      if (typeof window.RTCPeerConnection === 'undefined') {
        return;
      }

      const pc   = new RTCPeerConnection({iceServers: []});
      const noop = () => {
      };
      pc.createDataChannel('');
      pc.createOffer(pc.setLocalDescription.bind(pc), noop);
      pc.onicecandidate = function (ice) {
        if (ice && ice.candidate && ice.candidate.candidate) {
          const hostname    = /\sudp\s\d+\s(\S+)\s\d+\styp\s/ig.exec(ice.candidate.candidate);
          pc.onicecandidate = noop;
          components.push({key: 'hostname', value: hostname ? hostname[1] : 'unknown'});
        }
      };
    });
  },
  mounted: function () {
    this.checkMaintenanceStatus();

    const errorForceLogin = localStorage.getItem(Common.localStorageKeys.user.errorForceLogin);
    if (errorForceLogin !== null) {
      this.errorMessages = [errorForceLogin];
      localStorage.removeItem(Common.localStorageKeys.user.errorForceLogin);
      localStorage.removeItem(Common.localStorageKeys.user.errorTransferRole);
      return;
    }
    const errorTransferRole = localStorage.getItem(Common.localStorageKeys.user.errorTransferRole);
    if (errorTransferRole !== null) {
      this.errorMessages = [errorTransferRole];
      localStorage.removeItem(Common.localStorageKeys.user.errorTransferRole);
    }
  },
  methods: {
    /**
     * メンテナンス状態を確認する。
     *
     * @returns {Promise<void>} 確認完了
     */
    async checkMaintenanceStatus() {
      try {
        await apiClient.get(apiList.maintenance.status);
      } catch (error) {
        if (error && error.message === Common.messages.errorMaintenanceMode) {
          this.errorMessages = [error.message];
        }
      }
    },
    formValidate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.onSubmit();
      }
    },
    onSubmit() {
      this.sending = true;
      const data   = {
        'login_id': this.form.login_id,
        'password': this.form.password,
        'meta'    : this.form.meta,
      };

      // 重複ログインの確認モーダルからだと、強制ログインするとのことなので、通常ログインする
      if (this.showSuspectedDuplicateLoginDialog) {
        this.callUserLogin(data);
        return;
      }

      // 重複ログインがないかチェックし、ログインを行う
      this.callValidateDuplicateLogin(data);
    },
    /**
     * 重複ログインの確認を行う
     * @param data
     */
    callValidateDuplicateLogin(data) {
      apiClient.post(apiList.user.validateDuplicateLogin, data)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.sending = false;
              return;
            }

            // 重複ログインが疑われる場合は、確認画面を表示する
            if (!response.data.recently_authenticated) {
              // 同一IDのトークンが存在しないまたは１時間更新されていないのであれば、ログアウトされているか利用されていないため、メッセージを表示しない
            } else if (response.data.suspected_duplicate_login) {
              // ブラウザフィンガープリントが異なる かつ トークンの更新が１時間内にあった場合は、重複ログインとみなす
              this.showSuspectedDuplicateLoginDialog = true;
              this.sending                           = false;
              return;
            }

            // それ以外は通常ログイン
            this.callUserLogin(data);
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.sending       = false;
          })
          .finally(() => {
          });
    },
    /**
     * ユーザーのログインを行う
     * @param data
     */
    callUserLogin(data) {
      apiClient.post(apiList.user.login, data)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.sending = false;
              return;
            }
            localStorage.removeItem(Common.localStorageKeys.map.hideNotifications);
            localStorage.setItem(Common.localStorageKeys.user.accessToken, response.data.account.access_token);
            localStorage.setItem(Common.localStorageKeys.user.accessTokenExpireIn, response.data.account.expires_in);
            localStorage.setItem(Common.localStorageKeys.user.fromLogin, Date.now().toString());
            this.getAuthAccountInformation();
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.sending       = false;
          })
          .finally(() => {
            this.showSuspectedDuplicateLoginDialog = false;
          });
    },
    /**
     * 重複ログインの確認モーダルをキャンセルした場合
     */
    onCancel() {
      this.showSuspectedDuplicateLoginDialog = false;
    },
    /**
     *
     */
    getAuthAccountInformation() {
      apiClientWithUserToken
          .get(apiList.jon.accounts.auth)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            localStorage.removeItem(Common.localStorageKeys.user.auth);
            localStorage.setItem(Common.localStorageKeys.user.auth, JSON.stringify(response.data));
            // Check trial info
            this.getTrialInfo();
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.sending       = false;
          })
          .finally(() => {
          });
    },
    /**
     *
     */
    getTrialInfo() {
      apiClientWithUserToken.get(apiList.trial.current_info)
          .then(response => {
            // Get redirectTo
            let redirectTo = localStorage.getItem(Common.localStorageKeys.redirectToUser);
            if (redirectTo !== null) {
              localStorage.removeItem(Common.localStorageKeys.redirectToUser);
              this.$router.replace(redirectTo);
              return;
            }
            this.$router.replace({name: 'MapInitial'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
    },
    /**
     * ユーザー識別用のメタデータを生成
     * @param components
     */
    generateUserMeta(components) {
      const self                    = this;
      // ブラウザフィンガープリントをメタ情報に追加
      this.form.meta['fingerPrint'] = this.$fingerprint.x64hash128(components.map((pair) => {
        self.form.meta[pair.key] = pair.value;
        return pair.value
      }).join(), 31)

      // タブ識別IDををメタ情報に追加
      this.form.meta['tabId'] = sessionStorage.tabID;
      sessionStorage.tabCount = 0;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

main {
  height: 100vh;
  min-height: 100vh;
}

form {
  margin-bottom: 50px;
}

.ml-20 {
  margin-left: 20px;
}

.md-20 {
  margin-bottom: 20px;
}

.md-card {
  .md-title {
    text-align: center;
  }
}

@media screen and (max-width: 960px) {
  .md-layout.md-alignment-top-right {
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.md-toolbar {
  &.header {
    top: 0;
    position: absolute;
  }

  .md-title {
    img {
      height: 52px;
      margin: 4px 0;
    }
  }
}

.ie-browser {
  .md-layout {
    flex-basis: auto;
  }

  .md-toolbar {
    height: 64px;
  }
}

.forgot-account-link {
  cursor: pointer;

  &:not(.md-button) {
    color: var(--md-theme-default-text-accent-on-background-variant, rgba(0, 0, 0, 0.54));
  }
}

.maintenance-detail {
  margin-top: 8px;
  text-align: left;
}

.maintenance-flash-message {
  padding: 12px 20px;
}

.maintenance-detail-link {
  color: #d9534f !important;
  font-size: 0.9em;
  font-weight: bold;
  text-decoration: underline;
}
</style>
